import smoothscroll from 'smoothscroll-polyfill';
import 'wicg-inert';

function initializePolyfills() {
  smoothscroll.polyfill();
}

export { initializePolyfills };
